import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SocialIcons from './SocialIcons';
import logo from '../assets/images/logo_sindicato_metalurgicos_bauru_retangular_fundo_transparente.png';

function Footer() {
    return (
        <footer className="footer">
            <Container style={{ background: '#CCC', padding: '30px' }}>
                <Row className="align-items-center">
                    <Col md={6} className="d-flex align-items-center">
                        <img
                            src={logo}
                            width="100"
                            className="d-inline-block align-top"
                            alt="Logo"
                        />
                    </Col>
                    <Col md={6} className="d-flex justify-content-end">
                        <SocialIcons />
                    </Col>
                </Row>
                <Row>
                    <Col className='text-center'>
                        Sindicato dos Metalúrgicos nas Indústrias Metalúrgicas Mecânicas e de Materiais Elétricos de Bauru e Região
                        <br/>
                        Rua Araujo Leite, 2-25 - Centro - Bauru/SP
                        <br/>
                        Telefone: (14) 3232-4367
                        <br/>
                        E-mail: sindimetalurgicos@uol.com.br
                        <hr className="footer-divider" />
                        <p className="mb-0">© {new Date().getFullYear()} Sindicato dos Metalúrgicos de Bauru e Região. Todos os direitos reservados.</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;